import tipComponent from "./tip.vue"

const tip = {}  /**生成对象 */

tip.install = Vue => {
    const tipConstructor = Vue.extend(tipComponent)  /**生成vue子类 */

    const instance = new tipConstructor()  /** 生成实例*/

    instance.$mount(document.createElement('div'))  /**将方法挂载到div上 */
    document.body.appendChild(instance.$el)  /**给页面添加DOM元素 */

    Vue.prototype.$tip = obj =>{
        instance.add(obj)
    }

    Vue.prototype.$tipDel = str =>{
        instance.del(str)
    }

    Vue.prototype.$tipClear = () =>{
        instance.clear()
    }

}

export default tip


//////////////////
// WEBPACK FOOTER
// ./static/plugin/tip/index.js
// module id = null
// module chunks = 